/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownDietaryRequirement } from '../models/db_DropdownDietaryRequirement';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DietaryRequirements {
    /**
     * Get a list of dietary requirements
     * @returns db_DropdownDietaryRequirement OK
     * @throws ApiError
     */
    public static listDietaryRequirements(): CancelablePromise<Array<db_DropdownDietaryRequirement>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dietary-requirements',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
